import { type ButtonProps, buttonVariants } from '@src/design-system/button';
import { cn } from '@src/design-system/helpers';

type PaginationLinkProps = {
  isActive?: boolean;
} & Pick<ButtonProps, 'size'> &
  React.ComponentProps<'a'>;

const PaginationLink = ({
  className,
  isActive,
  size = 'iconSm',
  ...props
}: PaginationLinkProps) => (
  <a
    aria-current={isActive ? 'page' : undefined}
    className={cn(
      buttonVariants({
        size,
      }),
      className,
      isActive ? 'bg-primary-100 hover:bg-primary-100' : 'hover:bg-transparent'
    )}
    {...props}
  />
);

PaginationLink.displayName = 'PaginationLink';

export default PaginationLink;
